import { useEffect, useState } from "react";
import {
  account_profile_status,
  addCarDoc,
  addCarInfo,
  addDriver,
  addEmeregencyInfo,
  allDrivers,
  deleteDriver,
  getCarDocuInfoByDid,
  getCarInfoByDid,
  getCarTypes,
  getCities,
  getDriverById,
  getDriverEmergencyInfoByDid,
  getStates,
  updateCarDoc,
  updateCarInfo,
  updateDriver,
  updateEmeregencyInfo,
} from "../../api/fetch";
import { ACC_STATUS, PRO_STATUS, RELATION_DATA } from "../../services/constant";
import { MenuItem } from "@mui/material";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert";
import { useAuth } from "../../services/AuthContext";

const FormOneSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required"),
  mobile_number: Yup.string()
    .length(10, "Mobile Number must be 10 digits")
    .required("Mobile Number is required"),
  weight: Yup.number()
    .typeError("Weight must be a number")
    .required("Weight is required"),
  height: Yup.number()
    .typeError("Height must be a number")
    .required("Height is required"),
  experience: Yup.string().required("Experience is required"),
  acc_status: Yup.string()
    .notOneOf(["Choose Status..."], "Account Status is required")
    .required(),
  pro_status: Yup.string()
    .notOneOf(["Choose Status..."], "Profile Status is required")
    .required(),
  state: Yup.string()
    .notOneOf(["Choose State..."], "State is required")
    .required(),
  city: Yup.string()
    .notOneOf(["Choose City..."], "City is required")
    .required(),
});

const FormTwoschema = Yup.object().shape({
  carName: Yup.string().required("Car Name is required"),
  carNo: Yup.string()
    .matches(/^[A-Z0-9]{1,10}$/, "Car Number must be in the format: XX-12345")
    .required("Car Number is required"),
  carType: Yup.string()
    .notOneOf(["Choose Type..."], "Car Type is required")
    .required("Car Type is required"),
});

const FormThreeSchema = Yup.object().shape({
  license: Yup.mixed().required("License is required"),
  carInsurance: Yup.mixed().required("Car Insurance is required"),
  carRc: Yup.mixed().required("Car RC is required"),
  insuranceExpiryDate: Yup.date()
    .required("Insurance Expiry Date is required")
    .nullable(),
});

const FormFourSchema = Yup.object().shape({
  fatherName: Yup.string().required("Father Name is required"),
  fatherNo: Yup.string()
    .matches(/^[0-9]{10}$/, "Father Number must be 10 digits")
    .required("Father Number is required"),
  emergencyNo: Yup.string()
    .matches(/^[0-9]{10}$/, "Emergency Number must be 10 digits")
    .required("Emergency Number is required"),
  relationName: Yup.string().required("Relation Name is required"),
  relationType: Yup.string().required("Relation Type is required"),
});

function Provider() {
  const [alldriver, setAllDriver] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const [carTypeData, setCarTypeData] = useState([]);
  const [driverInfo, setDriverInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [errorsFormOne, setErrorsFormOne] = useState({});

  const [carInfoData, setCarInfoData] = useState([]);
  const [docInfoData, setDocInfoData] = useState([]);

  const { drv, setDrv } = useAuth();
  console.log("FORMMMRMMR::", drv);

  const [form, setForm] = useState(1);
  const [openEdit, setOpenEdit] = useState(false);
  const [driv_id, setDriv_id] = useState("");
  console.log("DRIVV IDDD::", driv_id);
  console.log("FORMMMRMMR::", form);

  const [fullName, setFullName] = useState("");
  const [mobile_number, setMobile_Number] = useState("");
  const [dob, setDOB] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [blood_g, setBlood_g] = useState("");
  const [experience, setExperience] = useState("");
  const [image, setImage] = useState(null);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [acc_status, setAcc_Status] = useState("");
  const [pro_status, setPro_Status] = useState("");
  const [preview, setPreview] = useState("");

  const [carName, setCarname] = useState("");
  const [carNo, setCarNo] = useState("");
  const [carType, setCarType] = useState("");
  const [images, setImages] = useState([]);

  const [fatherName, setFatherName] = useState("");
  const [fatherNo, setFatherNo] = useState("");
  const [emergencyNo, setEmergencyNo] = useState("");
  const [relationName, setRelationName] = useState("");
  const [relationType, setRelationType] = useState("");

  const [formValues, setFormValues] = useState({
    license: null,
    carInsurance: null,
    carRc: null,
    insuranceExpiryDate: "",
  });

  const [previews, setPreviews] = useState({
    license: "",
    carInsurance: "",
    carRc: "",
  });

  const navigate = useNavigate();

  //Validate Form One -------->>>>>>
  const validateFormOne = async () => {
    try {
      await FormOneSchema.validate(
        {
          fullName,
          mobile_number,
          weight,
          height,
          experience,
          image,
          state,
          city,
          acc_status,
          pro_status,
        },
        { abortEarly: false }
      );
      return null; // No errors
    } catch (err) {
      // Extract errors
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      return newErrors;
    }
  };

  //Validate Form Two -------->>>>>>
  const validateFormTwo = async () => {
    try {
      await FormTwoschema.validate(
        {
          carName,
          carNo,
          carType,
        },
        { abortEarly: false }
      );
      return null; // No errors
    } catch (err) {
      // Extract errors
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      return newErrors;
    }
  };

  //Validate Form Three -------->>>>>>
  const validateFormThree = async () => {
    try {
      await FormThreeSchema.validate(
        {
          ...formValues,
        },
        { abortEarly: false }
      );
      return null; // No errors
    } catch (err) {
      // Extract errors
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      return newErrors;
    }
  };

  //Validate Form Three -------->>>>>>
  const validateFormFour = async () => {
    try {
      await FormFourSchema.validate(
        {
          fatherName,
          fatherNo,
          emergencyNo,
          relationName,
          relationType,
        },
        { abortEarly: false }
      );
      return null; // No errors
    } catch (err) {
      // Extract errors
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      return newErrors;
    }
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file) {
      // Generate preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews((prev) => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(file);
    }

    setFormValues({
      ...formValues,
      [name]: file,
    });
  };

  // Handle date input change
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleDOBChange = (event) => {
    setDOB(event.target.value);
  };

  // Handle preview removal
  const handleRemovePreview = (name) => {
    setPreviews((prev) => ({ ...prev, [name]: "" }));
    setFormValues((prev) => ({ ...prev, [name]: null }));
  };

  const handlerefresh = () => {
    setRefresh(!refresh);
  };

  useEffect(() => {
    fetchAllDrivers();
  }, [refresh]);

  useEffect(() => {
    fetchAllStates();
    fetchAllCarTypes();
  }, []);

  const fetchAllStates = async () => {
    try {
      const res = await getStates();
      setStateData(res?.states);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const fetchAllCities = async (SID) => {
    try {
      const res = await getCities(SID);
      setCitiesData(res?.cities);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const fetchAllCarTypes = async () => {
    try {
      const res = await getCarTypes();
      setCarTypeData(res?.cartypes);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const fetchAllDrivers = async () => {
    setIsLoading(true);
    try {
      const res = await allDrivers();

      console.log("ALL DRIVERR ::", res?.data);
      // alert(JSON.stringify(res?.data));

      setAllDriver(res?.data);
      setIsLoading(false);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const handleActive = async (rowData) => {
    const body = {
      id: rowData?.id,
      mobile_number: rowData?.mobile_number,
      astatus: true,
    };

    try {
      await account_profile_status(body);

      handlerefresh();
    } catch (error) {
      console.log("Eroor ::", error);
    }
  };

  const handleApprove = async (rowData, Reject) => {
    const body = {
      id: rowData?.id,
      mobile_number: rowData?.mobile_number,
      pstatus: Reject ? false : true,
      rejectProfile: Reject,
    };

    if (Reject) {
      Swal({
        title: "Are you sure?",
        text: "Reject this Driver Record!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await account_profile_status(body);
          Swal({
            title: "Success",
            text: `${rowData?.driver_name} has been Rejected.`,
            timer: 1000,
          });
          handlerefresh();
        } else {
          Swal("Cancelled", "Your Driver Record is safe :)", "error");
        }
      });
    } else {
      try {
        await account_profile_status(body);

        handlerefresh();
      } catch (error) {
        console.log("Error :", error);
      }
    }
  };

  // Fill Account Status -------------->
  const fillAcconutStatus = () => {
    return ACC_STATUS?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Fill Profile Status -------------->
  const fillProfileStatus = () => {
    return PRO_STATUS?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Fill States -------------->
  const fillStates = () => {
    return stateData?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Fill Cities -------------->
  const fillCities = () => {
    return citiesData?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Fill Car TYpes -------------->
  const fillCarTypes = () => {
    return carTypeData.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Fill Relation  -------------->
  const fillRelationsType = () => {
    return RELATION_DATA?.map((item) => {
      return (
        <MenuItem sx={{ fontFamily: "Poppins" }} value={item?.id}>
          {item?.name}
        </MenuItem>
      );
    });
  };

  // Handle Select Account Status
  const handleState = (event) => {
    setState(event.target.value);
    fetchAllCities(event.target.value);
  };

  // Handle Select Account Status
  const handleCity = (event) => {
    setCity(event.target.value);
  };

  // Handle Select Account Status
  const handleAccount = (event) => {
    setAcc_Status(event.target.value);
  };

  // Handle Select Profile Status
  const handleProfile = (event) => {
    setPro_Status(event.target.value);
  };

  // Handle Select Profile Status
  const handleCarType = (event) => {
    setCarType(event.target.value);
  };

  /// Manage Upload Image ------>
  const handleImage = (event) => {
    setImage(event.target.files[0]);
    setPreview(URL.createObjectURL(event.target.files[0]));
  };

  // Handle For Image ---------->>>>>>>>>>>>>>>
  const handleCarImages = (files) => {
    setImages(files);
  };

  // Handle Relation TYpe ---------->>>>>>>>>>>>>>>
  const handleRelationType = (event) => {
    setRelationType(event.target.value);
  };

  // Handle Form One  ------->>>>>>>>>
  const handleSubmitFormOne = async () => {
    const formErrors = await validateFormOne();
    if (formErrors) {
      setErrorsFormOne(formErrors);
    } else {
      setErrorsFormOne({});
      console.log("Form submitted with", {
        fullName,
        mobile_number,
        dob,
        weight,
        height,
        blood_g,
        experience,
        image,
        state,
        city,
        acc_status,
        pro_status,
      });

      formOnemutation.mutate({
        name: fullName,
        mobile_number,
        dob,
        weight,
        height,
        blood_g,
        experience,
        image,
        state,
        city,
        acc_status,
        pro_status,
        drv_id: driv_id,
      });
    }
  };

  const formOnemutation = useMutation({
    mutationFn: (credential) =>
      openEdit ? updateDriver(credential) : addDriver(credential),

    onSuccess: (res) => {
      if (openEdit) {
        if (res?.status) {
          setForm(2);
          // setDrv(res?.data);

          Swal({
            title: res?.msg,
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      } else {
        if (res?.status) {
          navigate("/Dashboard/addDriver2");
          setDrv(res?.data);

          Swal({
            title: "Driver Added successfully.",
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      }
    },
    onError: (error) => {
      console.log("Login ERROR ::", error);
    },
  });

  const handleSubmitFormTwo = async () => {
    const drv_id = drv?.id;
    // Log drv_id to ensure it's being set
    console.log("drv_id:", drv_id);

    const formErrors = await validateFormTwo();
    if (formErrors) {
      setErrorsFormOne(formErrors);
    } else {
      setErrorsFormOne({});
      console.log("Form submitted with", {
        carName,
        carNo,
        carType,
        images,
      });

      FormTwomutation.mutate({
        drv_id: drv_id,
        name: carName,
        number: carNo,
        type: carType,
        images,
      });
    }
  };

  const FormTwomutation = useMutation({
    mutationFn: (credential) =>
      form === 2 ? updateCarInfo(credential) : addCarInfo(credential),
    onSuccess: (res) => {
      if (form === 2) {
        if (res?.status) {
          setForm(3);
          Swal({
            title: "Car Information Update successfully.",
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      } else {
        if (res?.status) {
          navigate("/Dashboard/addDriver3");

          Swal({
            title: "Car Information Added successfully.",
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      }
    },
    onError: (error) => {
      console.log("Login ERROR ::", error);
    },
  });

  const handleSubmitFormThree = async () => {
    const drv_id = drv?.id;
    const formErrors = await validateFormThree();
    if (formErrors) {
      setErrorsFormOne(formErrors);
    } else {
      setErrorsFormOne({});
      console.log("Form submitted with", {
        formValues,
      });
      FormThreemutation.mutate({
        drv_id,
        insuranceExpiry: formValues?.insuranceExpiryDate,
        licence: formValues?.license,
        car_insurance: formValues?.carInsurance,
        rc: formValues?.carRc,
      });
    }
  };

  const FormThreemutation = useMutation({
    mutationFn: (credential) =>
      form === 3 ? updateCarDoc(credential) : addCarDoc(credential),

    onSuccess: (res) => {
      if (form === 3) {
        if (res?.status) {
          setForm(4);
          Swal({
            title: "Car Document Added successfully.",
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      } else {
        if (res?.status) {
          navigate("/Dashboard/addDriver4");

          Swal({
            title: "Car Document Added successfully.",
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      }
    },
    onError: (error) => {
      console.log("Login ERROR ::", error);
    },
  });

  const handleSubmitFormFour = async () => {
    const drv_id = drv?.id;

    const formErrors = await validateFormFour();
    if (formErrors) {
      setErrorsFormOne(formErrors);
    } else {
      setErrorsFormOne({});
      console.log("Form submitted with", {
        formValues,
      });

      FormFourmutation.mutate({
        drv_id,
        fathername: fatherName,
        fathernumber: fatherNo,
        emergency_number: emergencyNo,
        relation_name: relationName,
        relation_type: relationType,
      });
    }
  };

  const FormFourmutation = useMutation({
    mutationFn: (credential) =>
      form === 4
        ? updateEmeregencyInfo(credential)
        : addEmeregencyInfo(credential),
    onSuccess: (res) => {
      if (form === 4) {
        if (res?.status) {
          navigate("/Dashboard/driver");
          handlerefresh();
          Swal({
            title: "Driver Emergency Added successfully.",
            timer: 2000,
          });
          // setOpenEdit(false);
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      } else {
        if (res?.status) {
          navigate("/Dashboard/driver");
          handlerefresh();
          Swal({
            title: "Driver Emergency Added successfully.",
            timer: 2000,
          });
        } else {
          Swal(
            {
              title: "Oopps!",
              text: res?.msg,
              timer: 3000,
            }
            //   Swal("Nice!", res?.data?.msg, "success")
          );
        }
      }
    },
    onError: (error) => {
      console.log("Login ERROR ::", error);
    },
  });

  const handleReset = () => {};

  const handleView = async (rowData) => {
    // console.log("EDITT ROW DATA ::", rowData);
    // open();

    const res = await getDriverById(rowData?.id);

    if (res?.status) {
      setDriverInfo(res?.data);
    }

    console.log("GET DRIVER BY ID DATAA ::--->>>>>>>", res);
  };

  const handleEdit = async (rowData) => {
    console.log("EDITT ROW DATA ::", rowData);
    // open();
    const d = new Date(rowData?.dob);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(d.getDate()).padStart(2, "0");

    const dd = `${year}-${month}-${day}`;

    setFullName(rowData?.name);
    setMobile_Number(rowData?.mobile_number);
    setBlood_g(rowData?.blood_group);
    setExperience(rowData?.experience);
    setWeight(rowData?.weight);
    setHeight(rowData?.height);
    setState(rowData?.state);
    fetchAllCities(rowData?.state);
    setCity(rowData?.city);
    setPreview(rowData?.image);
    setImage(rowData?.image);
    setAcc_Status(rowData?.account_status);
    setPro_Status(rowData?.profile_status);
    setDOB(dd);
    setDriv_id(rowData?.id);
  };

  const handleDelete = async (rowData) => {
    console.log("DELETEEE ::", rowData);

    var id = rowData?.id;

    Swal({
      title: "Are you sure?",
      text: "Delete this Driver Record!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        const res = await deleteDriver(id);
        Swal({
          title: "Success",
          text: res?.msg,
          timer: 1000,
        });
        fetchAllDrivers();
      } else {
        Swal("Cancelled", "Your Driver Record is safe :)", "error");
      }
    });
  };

  const open = () => {
    setOpenEdit(!openEdit);
  };

  useEffect(() => {
    if (driv_id) {
      fetchCarInfo();
      fetchCarDocuInfo();
      fetchDriverEmgenyInfo();
    }
  }, [form, driv_id]);

  // Fetch Car Informationn
  const fetchCarInfo = async () => {
    try {
      var formData = driv_id;

      const res = await getCarInfoByDid(formData);

      setCarInfoData(res?.data[0]);
      FillCarInfoForm(res?.data[0]);
    } catch (error) {
      console.log("Errror ::", error);
    }
  };

  // Fetch Car Docuemnt  Informationn
  const fetchCarDocuInfo = async () => {
    try {
      var formData = driv_id;

      const res = await getCarDocuInfoByDid(formData);
      console.log("RSJKHD ::", res?.data);
      setDocInfoData(res?.data);
      FillCarDocuInfoForm(res?.data);
    } catch (error) {
      console.log("Errror ::", error);
    }
  };

  // Fetch Driver Emergency Informationn
  const fetchDriverEmgenyInfo = async () => {
    try {
      var formData = driv_id;

      const res = await getDriverEmergencyInfoByDid(formData);
      console.log("RSJKHD EMERGECYCY ::", res?.data);
      FillDriverEmergencyInfoForm(res?.data);
    } catch (error) {
      console.log("Errror ::", error);
    }
  };

  // Form Two Car Information ----->>>>>>>
  const FillCarInfoForm = async (rowData) => {
    setCarname(rowData?.name);
    setCarNo(rowData?.number);
    setCarType(rowData?.type);
  };

  console.log("Car Doc VLUE::", formValues);
  console.log("Car Doc PREE::", previews);
  console.log("Car Doc IFOFO ::", docInfoData);

  // Form Three Car Docuemnt Information ----->>>>>>>
  const FillCarDocuInfoForm = async (rowData) => {
    const d = new Date(rowData?.insuranceexpiry);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(d.getDate()).padStart(2, "0");

    const dd = `${year}-${month}-${day}`;
    setFormValues({
      license: rowData?.licence_image_url || null,
      carInsurance: rowData?.car_insurance_image_url || null,
      carRc: rowData?.rc_image_url || null,
      insuranceExpiryDate: dd || "",
    });
    setPreviews({
      license: rowData?.licence_image_url || null,
      carInsurance: rowData?.car_insurance_image_url || null,
      carRc: docInfoData?.rc_image_url || null,
    });
  };

  // Form Four Driver Emergecny Information ----->>>>>>>
  const FillDriverEmergencyInfoForm = async (rowData) => {
    setFatherName(rowData?.fathername);
    setFatherNo(rowData?.fathernumber);
    setEmergencyNo(rowData?.emergency_number);
    setRelationName(rowData?.relation_name);
    setRelationType(rowData?.relation_type);
  };

  return {
    form,
    setForm,
    handlerefresh,

    alldriver,
    isLoading,
    handleActive,
    handleApprove,
    fillAcconutStatus,
    fillProfileStatus,
    handleImage,
    handleAccount,
    handleProfile,
    fillStates,
    fillCities,
    handleState,
    handleCity,
    handleSubmitFormOne,
    handleReset,
    handleDOBChange,

    fullName,
    setFullName,
    mobile_number,
    setMobile_Number,
    dob,
    setDOB,
    preview,
    weight,
    setWeight,
    height,
    setHeight,
    blood_g,
    setBlood_g,
    experience,
    setExperience,
    image,
    state,
    city,
    acc_status,
    pro_status,

    errorsFormOne,

    handleCarType,
    handleCarImages,
    handleSubmitFormTwo,
    fillCarTypes,

    carName,
    setCarname,
    carNo,
    setCarNo,
    carType,
    images,
    carInfoData,

    handleSubmitFormThree,
    handleDateChange,
    handleFileChange,
    handleRemovePreview,
    formValues,
    previews,

    handleRelationType,
    handleSubmitFormFour,
    fillRelationsType,
    fatherName,
    setFatherName,
    fatherNo,
    setFatherNo,
    emergencyNo,
    setEmergencyNo,
    relationName,
    setRelationName,
    relationType,
    setRelationType,

    handleDelete,
    handleEdit,
    handleView,
    openEdit,
    setOpenEdit,
    driverInfo,
  };
}

export default Provider;
